import useMediaQuery from '@material-ui/core/useMediaQuery'
import ApplyFilters from 'Components/UI/Atoms/Table/Filter'
import SearchTable from 'Components/UI/Atoms/Table/Search'
import { useWindowSize } from 'react-use'

function Options(functions) {
  const {
    render,
    filters,
    setRender,
    setSort,
    setSearch,
    setOffset,
    setFilters,
    onFiltersChange,
    isSearching,
    count,
    textPlaceholder,
    searchEnabled = true,
    expandableRows = false,
    filterEnabled = true,
    renderExpandableRow,
    selectableRows = 'none',
    customToolbarSelect,
    customToolbar,
    padding,
    isRowSelectable,
    setRowProps,
    rows,
    onRowClick,
    searchFirst,
    columns,
  } = functions

  const upsertFilter = (filtersString, name, value) => {
    const base = filtersString || ''
    const parts = base
      .split('&')
      .filter(Boolean)
      .filter((p) => !p.startsWith(`${name}=`))

    if (value !== undefined && value !== null && value !== '') {
      parts.push(`${name}=${value}`)
    }

    return parts.length ? `&${parts.join('&')}` : ''
  }

  const buildFiltersFromFilterList = (filterList) => {
    const safeColumns = Array.isArray(columns) ? columns : []
    const safeFilterList = Array.isArray(filterList) ? filterList : []

    let next = ''
    safeColumns.forEach((col, idx) => {
      const name = col?.name
      const value = Array.isArray(safeFilterList[idx]) ? safeFilterList[idx][0] : undefined
      if (name && value !== undefined && value !== null && value !== '') {
        next = upsertFilter(next, name, value)
      }
    })
    return next
  }

  // eslint-disable-next-line
  const { width, height } = useWindowSize()

  const mediumViewport = useMediaQuery('(min-width:600px)')

  return {
    onRowClick: onRowClick,
    isRowSelectable: isRowSelectable,
    count: count,
    search: searchEnabled,
    expandableRows: expandableRows,
    renderExpandableRow: renderExpandableRow,
    expandableRowsHeader: false,
    selectableRows: selectableRows,
    customToolbarSelect: (selectedRows) => customToolbarSelect(selectedRows),
    filter: filterEnabled,
    filterType: 'dropdown',
    print: false,
    filterArrayFullMatch: true,
    responsive: 'standard',
    download: false,
    rowsPerPageOptions: [],
    viewColumns: false,
    tableBodyHeight:
      height - (mediumViewport ? (!filters ? 197 : 237) : document.title === 'Stock' ? 376 : 230),
    tableBodyMaxHeight:
      height - (mediumViewport ? (!filters ? 197 : 237) : document.title === 'Stock' ? 376 : 230),
    rowsPerPage: rows ? rows : 25,
    sort: true,
    serverSide: true,
    setRowProps: setRowProps,
    textLabels: {
      pagination: {
        next: 'Siguiente página',
        previous: 'Página anterior',
        displayRows: 'de',
        filter: {
          title: 'Filtros',
          reset: 'Resetear',
        },
      },
      toolbar: {
        filter: 'Filtros',
        filterTable: 'Filtros',
        search: 'Buscador rápido',
      },
      filter: {
        all: 'Todos',
        title: 'Filtros',
        reset: 'Resetear',
      },
      body: {
        noMatch: isSearching
          ? 'Buscando resultados...'
          : !searchFirst
            ? 'No se encontraron resultados'
            : 'Realice alguna búsqueda primero!',
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      selectedRows: {
        text: 'pedido(s) seleccionado(s)',
      },
    },
    setTableProps: () => {
      return {
        size: 'small',
        padding,
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          setOffset(tableState.page)
          setRender(!render)
          break
        case 'sort':
          if (
            tableState.sortOrder.direction !== 'none' &&
            Object.keys(tableState.sortOrder).length > 0
          ) {
            setSort({
              orderBy: tableState.sortOrder.name,
              order: tableState.sortOrder.direction,
            })
            setOffset(0)
            setRender(!render)
          } else {
            setSort({ orderBy: 'id', order: 'desc' })
            setOffset(0)
            setRender(!render)
          }
          break
        case 'onSearchClose':
          setOffset(0)
          setSearch()
          break
        default:
          break
      }
    },
    onFilterChange: (column, filterList, type, index) => {
      const columnName = typeof column === 'string' ? column : column?.name
      const nextValue = Array.isArray(filterList?.[index]) ? filterList[index][0] : undefined

      if (type === 'reset') {
        setFilters('')
        if (typeof onFiltersChange === 'function') {
          onFiltersChange({ type: 'reset', filtersString: '', columnName, filterList })
        }
        setOffset(0)
        setRender(!render)
        return
      }

      if ((type === 'chip' || type === 'custom') && nextValue !== undefined && nextValue !== '') {
        const next = upsertFilter(filters, columnName, nextValue)
        setFilters(next)
        if (typeof onFiltersChange === 'function') {
          onFiltersChange({ type, filtersString: next, columnName, value: nextValue, filterList })
        }
        setOffset(0)
        setRender(!render)
      }
      if ((type === 'chip' || type === 'custom') && typeof column === 'string') {
        let filtersSplitted = filters.split('&')
        let indexToDelete = filtersSplitted.findIndex((element) => element.includes(column))
        let filtersDeleted = filtersSplitted.splice(indexToDelete, 1)[0]
        let newFilters = filtersDeleted ? filters.replace('&' + filtersDeleted, '') : filters
        setFilters(newFilters)
        if (typeof onFiltersChange === 'function') {
          onFiltersChange({
            type,
            filtersString: newFilters,
            columnName: column,
            value: '',
            filterList,
          })
        }
        setOffset(0)
        setRender(!render)
      }
    },

    onFilterConfirm: (filterList) => {
      const next = buildFiltersFromFilterList(filterList)
      setFilters(next)

      if (typeof onFiltersChange === 'function') {
        onFiltersChange({ type: 'confirm', filtersString: next, filterList })
      }

      setOffset(0)
      setRender(!render)
    },
    customSearchRender: (searchText, handleSearch, hideSearch, _options) => {
      function confirmSearch(text) {
        if (text === undefined || text === '') {
          hideSearch()
        } else {
          setOffset(0)
          setSearch(text)
          setRender(!render)
        }
      }

      function discardSearch(text) {
        if (text === undefined) {
          hideSearch()
        } else {
          setOffset(0)
          hideSearch()
          setSearch()
          setRender(!render)
        }
      }
      return (
        <SearchTable
          confirmSearch={confirmSearch}
          discardSearch={discardSearch}
          textPlaceholder={textPlaceholder}
        />
      )
    },
    confirmFilters: true,
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <ApplyFilters currentFilterList={currentFilterList} applyNewFilters={applyNewFilters} />
      )
    },
    customToolbar: customToolbar,
  }
}

export { Options }
